var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1.5C3.89543 1.5 3 2.39543 3 3.5V19.5C3 20.6046 3.89543 21.5 5 21.5H6.063C6.28502 22.3626 7.06807 23 7.99999 23H20C21.1046 23 22 22.1046 22 21V9C22 8.73478 21.8946 8.48043 21.7071 8.29289L16.7071 3.29289C16.5196 3.10536 16.2652 3 16 3H14.9142L13.7071 1.79289C13.5196 1.60536 13.2652 1.5 13 1.5H5ZM6.67708 3.5L5 3.5V19.5L5.99999 19.5111V5C5.99999 4.40265 6.26187 3.86647 6.67708 3.5ZM20 20.8164H12.8598H7.99999V5L14 5V10C14 10.5523 14.4477 11 15 11H20V20.8164ZM16 9H19.5858L16 5.41421V9Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.51872643.svg";
export { ForwardRef as ReactComponent };